import { usePhotoFilenameTemplateQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { Spin } from 'antd'
import { useRefetchWithParent } from '../../../../../../hooks/useRefetchWithParent'
import { PhotoFilename } from '../../../../PhotoFilenameContext/types'
import { usePhotoFilenamesContext } from '../../../../PhotoFilenameContext'
import { useProjectContext } from 'context/ProjectContext'

const Template: React.FC<PhotoFilename> = ({ id: classTypeId }) => {
  const { projectId } = useProjectContext()
  const { loading: parentLoading } = usePhotoFilenamesContext()
  const { data, loading, refetch } = usePhotoFilenameTemplateQuery({
    ...DefaultQueryHookOptions,
    variables: { input: { projectId, classTypeId } },
  })
  useRefetchWithParent({ parentLoading, refetch })
  return (
    <Spin spinning={loading ?? false} size="small">
      {data?.photoFilenameTemplate}
    </Spin>
  )
}

export default Template
